export default __webpack_public_path__ + "static/media/eigenheim_icons_fence.44e48a52.svg";